import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-switch-button',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './switch-button.component.html',
  styleUrl: './switch-button.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SwitchButtonComponent),
      multi: true,
    },
  ],
})
export class SwitchButtonComponent {
  @Input() label: string = '';
  @Input() checked: boolean = false;

  @Output() toggled = new EventEmitter<boolean>();

  onToggle() {
    this.checked = !this.checked;
    this.toggled.emit(this.checked);
  }
}
